import { render, staticRenderFns } from "./IntegrationOrderStatus.vue?vue&type=template&id=4baab72c"
import script from "./IntegrationOrderStatus.vue?vue&type=script&lang=js"
export * from "./IntegrationOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports